export default __webpack_public_path__ + "static/media/founding-member.fa7bd3fe.png";